<template>
  <div>
    <h1>Privacy Policy</h1>
    <p><strong>PrimeFusion Oy (Business ID: 3511657-2)</strong></p>

    <h2>1. Introduction</h2>
    <p>PrimeFusion Oy ("Company," "we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your data when using our Services.</p>

    <h2>2. Data We Collect</h2>
    <ul>
      <li><strong>Personal Data:</strong> First name, last name, email address.</li>
      <li><strong>Non-Personal Data:</strong> Analytics data (e.g., usage patterns, device information) collected through Mixpanel.</li>
    </ul>

    <h2>3. How We Use Your Data</h2>
    <ul>
      <li>Provide and improve our Services.</li>
      <li>Communicate with you about updates and support.</li>
      <li>Analyze usage trends through Mixpanel to enhance user experience.</li>
    </ul>

    <h2>4. Data Sharing</h2>
    <p>We do not share personal data with any third parties. Non-personal analytics data is processed via Mixpanel for analytical purposes.</p>

    <h2>5. Data Security</h2>
    <p>We implement appropriate security measures to protect your personal data from unauthorized access or disclosure. However, no method of transmission over the internet is completely secure.</p>

    <h2>6. User Rights</h2>
    <ul>
      <li>You may request access, correction, or deletion of your personal data by contacting us.</li>
      <li>You have the right to withdraw consent where applicable.</li>
    </ul>

    <h2>7. Changes to This Policy</h2>
    <p>We may update this Privacy Policy from time to time. Any changes will be posted on our website, and continued use of our Services constitutes acceptance of the changes.</p>

    <h2>8. Contact Us</h2>
    <p>For any questions regarding this Privacy Policy, please contact us at info@primefusion.fi</p>
  </div>
</template>
